import { createFileRoute } from "@tanstack/react-router";
import SaintEastCoastPage from "@/pages/learn/SaintEastCoastPage";
import { pageSaintEastCoast } from "@/pages/learn/learnDataSaintEastCoast";
export const Route = createFileRoute("/learn/saint-tms-east-coast")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SAINT® TMS on the East Coast | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "Finding SAINT® TMS on the East Coast: why availability is limited, how to identify and compare verified providers, and why patients travel to Coral Springs.",
        },
        {
          property: "og:title",
          content: "SAINT® TMS on the East Coast | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "Finding SAINT® TMS on the East Coast: why availability is limited, how to identify and compare verified providers, and why patients travel to Coral Springs.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/learn/saint-tms-east-coast",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/saint-tms-east-coast",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(pageSaintEastCoast.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintEastCoastPage />;
}
